<script setup lang="ts">
import { onMounted } from 'vue';

import { OfflineBanner } from '~/components/offline-banner';
import { ToastViewport } from '~/components/toast';
import { usePwaUpdate } from '~/composables/use-pwa-update';
import { useTheme } from '~/composables/use-theme';

const { applyStoredTheme } = useTheme();
usePwaUpdate();

onMounted(() => {
  applyStoredTheme();
});
</script>

<template>
  <OfflineBanner />
  <RouterView />
  <ToastViewport />
</template>
